import React from 'react';

function back() {
    window.history.back();
}

export default function() {
    if (window.history.length === 1) {
        return null;
    }

    return (
        <button onClick={back}>&lt;&lt; назад</button>
    );
}
